// extracted by mini-css-extract-plugin
export default {"container":"SideBarTabMetadata_container__88t0+"};